module.exports = __webpack_public_path__ + "static/img/2018.b1bb5f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic/2018.jpg
// module id = O1KD
// module chunks = 52